<template>
  <tr v-if="policySubtypes && policySubtypes.subtype_names[0]">
    <td class="cell-sub-header">
      &nbsp;
    </td>
    <!--
      I need UX direction before implementing this
      <td
        :colspan="isPlanBased ? 1 : 2"
        class="cell-sub-header"
      >
        &nbsp;
      </td>
    -->
    <template v-if="policySubtypes.subtype_names[0] !== 'null'">
      <!-- subtype name cell should take up 1 colspan if is equal to policy subtype count. -->
      <td
        v-for="subtype in policySubtypes.subtype_names"
        :key="`policy-${subtype}`"
        :colspan="subtypeColspans[containerId] / policySubtypes.subtype_names.length"
        class="cell-sub-header"
        v-text="subtype"
      />
    </template>
  </tr>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  /**
   * A component that renders the category title for a Plan Design Attribute.
   *
   * @vuedoc
   * @exports PlanDesign/CategoryTitle
   * @category Components
   */
  export default {
    name: 'PlanDesignCategoryTitle',
    props: {
      containerId: {
        type: [Number, String],
        required: true,
      },
      groupings: {
        type: Array,
        default: () => [],
      },
      subtypes: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      ...mapGetters('planDesignAttributes', ['isPlanBased']),
      ...mapState('planDesignAttributes', ['subtypeColspans']),
      /**
       * Get the policy subtype for the appropriate container.
       * I need to work UX to figure out how we want to handle showing subtypes for class based products but I threw some logic in there as a POC for later.
       *
       * @returns {object}
       */
      policySubtypes() {
        let policySubtypes;

        if (this.isPlanBased) {
          policySubtypes = this.subtypes.products[0].containers.find(({ id }) => id === this.containerId);
        } else {
          const subtypes = this.groupings.find((grouping) => (
            grouping.subtypes_by_product.products[0].subtype_names[0] !== null
          ));

          if (subtypes) {
            [policySubtypes] = subtypes.subtypes_by_product.products;
          }
        }

        return policySubtypes;
      },
    },
  };
</script>

<style lang="scss" scoped>
  tr {
    background: $tf-light-blue;
    border-right: 0;
  }

  td {
    padding: 11px 0;
    font-weight: bold;
    text-align: center;
  }
</style>
